import { Component, Input, OnInit } from '@angular/core';
import { IBoxSettingsData } from '@pdqdev/pdq-shared/dist/interfaces';
import { CarrierPackages } from '@pdqdev/pdq-shared/dist/entities';

@Component({
  selector: 'app-settings-package-details',
  templateUrl: './package-details.component.html',
  styleUrls: ['./package-details.component.scss'],
  standalone: false,
})
export class SettingsPackageDetailsComponent implements OnInit {
  @Input() package: IBoxSettingsData;
  @Input() isCarrier: boolean;

  constructor() {}
  ngOnInit(): void {
    if (this.package?.token) {
      const isMissingDimensions = CarrierPackages?.find((p) => p?.token === this.package.token)?.isMissingDimensions;
      if (isMissingDimensions) {
        this.package.isMissingDimensions = isMissingDimensions;
      }
    }
  }
}
